import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect x=\"5.875\" y=\"4\" width=\"11.875\" height=\"1.5\" rx=\"0.75\" fill=\"#1D2522\"></rect><rect x=\"2\" y=\"4\" width=\"1.875\" height=\"1.5\" rx=\"0.75\" fill=\"#1D2522\"></rect><rect x=\"5.875\" y=\"9.5\" width=\"11.875\" height=\"1.5\" rx=\"0.75\" fill=\"#1D2522\"></rect><rect x=\"2\" y=\"9.5\" width=\"1.875\" height=\"1.5\" rx=\"0.75\" fill=\"#1D2522\"></rect><rect x=\"5.875\" y=\"15\" width=\"11.875\" height=\"1.5\" rx=\"0.75\" fill=\"#1D2522\"></rect><rect x=\"2\" y=\"15\" width=\"1.875\" height=\"1.5\" rx=\"0.75\" fill=\"#1D2522\"></rect>", 6)
  ])))
}
export default { render: render }